import { render, staticRenderFns } from "./detaile.vue?vue&type=template&id=02231afc&scoped=true&"
import script from "./detaile.vue?vue&type=script&lang=js&"
export * from "./detaile.vue?vue&type=script&lang=js&"
import style0 from "./detaile.vue?vue&type=style&index=0&id=02231afc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02231afc",
  null
  
)

export default component.exports